import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import { createDateField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum MallOrdersFilterKeys {
  completedAt = "completedAt"
}

export interface MallOrdersListFilterOpts {
  completedAt: FilterOpts<MinMax>;
}

const messages = defineMessages({
  completedAt: {
    defaultMessage: "Order Completion Date",
    description: "order completion date"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: MallOrdersListFilterOpts
): IFilter<MallOrdersFilterKeys> {
  return [
    {
      ...createDateField(
        MallOrdersFilterKeys.completedAt,
        intl.formatMessage(messages.completedAt),
        opts.completedAt.value
      ),
      active: opts.completedAt.active
    }
  ];
}
